import graphic from './graphic.png';
import popper from './popper.png';
import organiser from './organiser.png';
import share from './share.png';

export { graphic, popper, organiser, share };
